module.exports = __webpack_public_path__ + "img/d844d7b.gif";